import { render, staticRenderFns } from "./scope61.vue?vue&type=template&id=4da9486d&scoped=true"
import script from "./scope61.vue?vue&type=script&lang=js"
export * from "./scope61.vue?vue&type=script&lang=js"
import style0 from "./scope61.vue?vue&type=style&index=0&id=4da9486d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da9486d",
  null
  
)

export default component.exports